import { render, staticRenderFns } from "./KhfyAdd.vue?vue&type=template&id=7e56726e"
import script from "./KhfyAdd.vue?vue&type=script&lang=js"
export * from "./KhfyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports